export const colors = {
  // Primary - Forest green (warm and inviting) for settings
  primary: '#2E7D32',
  primaryLight: '#60AD5E',
  primaryDark: '#005005',

  // Background
  background: '#FAFAFA',
  backgroundDark: '#121212',

  // Text - High contrast for elderly users
  textPrimary: '#212121',
  textSecondary: '#757575',
  textOnPrimary: '#FFFFFF',
  textOnDark: '#FFFFFF',

  // Overlay for photo frame
  overlayLight: 'rgba(255, 255, 255, 0.85)',
  overlayDark: 'rgba(0, 0, 0, 0.65)',

  // Semantic colors
  success: '#4CAF50',
  error: '#D32F2F',
  warning: '#FFA000',

  // UI elements
  cardBackground: '#FFFFFF',
  border: '#E0E0E0',
  disabled: '#BDBDBD',

  // Dark theme - Warm peach (shared across frame and settings)
  dark: {
    // Primary accent
    primary: '#ff9e80',
    primaryDark: '#e68a6e',
    primaryLight: 'rgba(255, 158, 128, 0.2)',

    // Text colors
    heading: '#ffe4d6',
    text: '#fafaf9',
    textMuted: '#a8a29e',
    textSubtle: '#78716c',

    // Backgrounds
    background: '#1c1917',
    backgroundAlt: '#292524',
    surface: 'rgba(41, 37, 36, 0.8)',
    surfaceLight: 'rgba(68, 64, 60, 0.4)',
    surfaceHover: 'rgba(68, 64, 60, 0.6)',

    // Borders
    border: 'rgba(231, 229, 228, 0.1)',
    borderLight: 'rgba(68, 64, 60, 0.3)',

    // Status colors
    success: '#4ade80',
    error: '#f87171',
    errorBg: 'rgba(248, 113, 113, 0.1)',
  },

  // Alias for backward compatibility
  frame: {
    primary: '#ff9e80',
    primaryDark: '#e68a6e',
    greeting: '#ffe4d6',
    background: '#1c1917',
    surface: 'rgba(41, 37, 36, 0.7)',
    surfaceLight: 'rgba(68, 64, 60, 0.4)',
    border: 'rgba(231, 229, 228, 0.1)',
    text: '#fafaf9',
    textMuted: '#a8a29e',
  },
} as const;

export type ColorName = keyof typeof colors;
